<template>
  <div>
    <div class="about">
      <div class="single-row">
        <div class="img-div">
          <img src="https://spkg.smartmice.cn/resources/images/official/meeting/1.jpg">
          <div class="meeting-title">
            <span>
              MICE + AI
            </span>
          </div>
        </div>
      </div>
      <div class="double-row">
        <div class="img-div">
          <img src="https://spkg.smartmice.cn/resources/images/official/meeting/2.jpg">
          <div class="meeting-title">
            <span>
              智能会议工具 世界无限连接
            </span>
          </div>
        </div>
      </div>
      <div class="single-row">
        <div class="img-div">
          <img src="https://spkg.smartmice.cn/resources/images/official/meeting/3.jpg">
          <div class="meeting-title">
            <span>
              人工智能 会议极简至无形
            </span>
          </div>
        </div>
      </div>
      <div class="double-row">
        <div class="img-div">
          <img src="https://spkg.smartmice.cn/resources/images/official/meeting/4.jpg">
          <div class="meeting-title">
            <span>
              人脸识别、语音识别，AI 高效会议工具
            </span>
          </div>
        </div>
      </div>
      <div class="single-row">
        <div class="img-div">
          <img src="https://spkg.smartmice.cn/resources/images/official/meeting/5.jpg">
          <div class="meeting-title">
            <span>
              人工智能会议 多种渠道无缝链接
            </span>
          </div>
        </div>
      </div>
      <div class="double-row">
        <div class="img-div">
          <img src="https://spkg.smartmice.cn/resources/images/official/meeting/6.jpg">
          <div class="meeting-title">
            <span>
              人工智能会议 多种语言无障碍沟通
            </span>
          </div>
        </div>
      </div>
      <div class="single-row">
        <div class="img-div">
          <img src="https://spkg.smartmice.cn/resources/images/official/meeting/7.jpg">
          <div class="meeting-title">
            <span>
              全新智能化会议模式
            </span>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import Footer from '@/components/Footer'
export default {
  name: 'Meeting',
  components: {
    Footer
  }
}
</script>
<style lang="less" scoped>
.about {
  margin-top: 80px;
  overflow: hidden;
}
.img-div {
    position: relative;
  }
  .img-div img {
    width: 100%;
  }
  .meeting-title {
    width: 100%;
    text-align: center;
    height: 27px !important;
  }

  .meeting-title span {
    background: #39C5D5;
    color: #FFFFFF;
    padding: 7px 13px;
  }
  @media(min-width: 767px) {
    .single-row {
      background: #F4F4F4;
      padding: 80px 0;
    }
    .double-row {
      background: #FFFFFF;
      padding: 80px 0;
    }
    .img-div {
      width: 56%;
      margin: 0 auto;
      position: relative;
    }
    .meeting-title span {
      font-size: 20px;
    }
    .meeting-title {
      margin-top: 35px;
    }
  }
  @media(max-width: 767px) {
    .single-row {
        background: #F4F4F4;
        padding: 30px 0 32px 0;
      }
      .double-row {
        background: #FFFFFF;
        padding: 30px 0 32px 0;
      }
      .img-div {
        position: relative;
        margin: 0 30px;
      }
    .meeting-title span {
      font-size: 14px;
    }
    .meeting-title {
      margin-top: 25px;
    }
  }
</style>
